export const INT_REGEX = /^\d*$/;
export const DOUBLE_REGEX = /^\d*(\.\d*)?$/;
export const MLFB_REGEX = /^[a-zA-Z0-9-]*$/;
